import type { CountrySettings } from "../CountrySettings.js";
import type { Customer } from "../Customer.js";
import type { CustomerType } from "../CustomerType.js";
import type { OrderInput } from "../Order.js";
import { getCustomerType } from "./getCustomerType.js";
import { getWeightInGramsOfOrder } from "./getWeightInGramsOfOrder.js";
import { isCountryInEuropeanUnion } from "./isCountryInEuropeanUnion.js";

export function hasOrderFreeDelivery(
	order: Pick<OrderInput, "products" | "deliveryAddress" | "couponCode">,
	countrySettings: CountrySettings[],
	customer: Customer | null,
): boolean {
	if (!isCountryInEuropeanUnion(order.deliveryAddress.country) || !customer) {
		return false;
	}

	const deliverySettings = countrySettings.find(({ country }) => country === order.deliveryAddress.country)?.data
		?.delivery;

	if (!deliverySettings) {
		throw new Error(`Delivery settings not found for country "${order.deliveryAddress.country}"`);
	}

	const freeDeliveryPriceThreshold = {
		B2c: deliverySettings.freeDeliveryPriceThresholdForRegisteredB2c,
		B2b: deliverySettings.freeDeliveryPriceThresholdForRegisteredB2b,
	}[getCustomerType(customer.pricingLevel)];

	return getWeightInGramsOfOrder(order) >= freeDeliveryPriceThreshold * 1000;
}
